<template>
  <div class="about">
    <header class="text-block">
      <h1>{{ section.title }}</h1>
      <p>{{ section.description }}</p>
    </header>
    <ul class="about-links">
      <li
        class="about-link-wrapper"
        v-for="link in categoriesLinks"
        v-bind:key="link.route"
      >
        <router-link
          class="about-link-block"
          v-bind:to="link.route"
        >
          <image-overlay
            v-bind:image-src="link.image.image"
            v-bind:image-alt="link.image.alt_text"
            v-bind:image-width="link.image.width"
            v-bind:image-height="link.image.height"
          >
            <h2>{{ link.text }}</h2>
          </image-overlay>
        </router-link>
      </li>
    </ul>
    <section class="text-block">
      <h2>Юридическая информация</h2>
      <p>
        ЧПУП «Ювелирная фирма «Стиль» зарегистрировано в Едином
        государственном регистре юридических лиц и индивидуальных
        предпринимателей за №290720519. Лицензия на право осуществления
        деятельности с драгоценными металлами и драгоценными камнями
        выдана Министерством финансов Республики Беларусь, № 02200/0064617.
      </p>
    </section>
    <section class="text-block to-jewelry-stores-owners">
      <h2>Владельцам ювелирных магазинов</h2>
      <p>
        Ювелирная фирма «Стиль» производит ювелирные изделия из золота 585
        и серебра 925 пробы. В разделе
        <router-link to="/catalog">«каталог золото»</router-link> и
        <router-link to="/catalogsilver">«каталог серебро»</router-link>
        вы можете познакомиться с нашим ассортиментом. Основу нашей коллекции
        составляют <strong>украшения собственного дизайна</strong> (
        <router-link to="catalog/earrings">серьги</router-link>,
        <router-link to="catalog/rings">кольца</router-link>,
        <router-link to="catalog/pendants">кулоны</router-link>,
        <router-link to="catalog/pendants">кресты</router-link>,
        <router-link to="catalog/signets">печатки</router-link>,
        <router-link to="catalog/bracelets">браслеты</router-link>,
        <router-link to="catalog/bracelets">цепи</router-link> и
        <router-link to="catalog/weddingrings">обручальные кольца</router-link>
        как с искусственными вставками, так и с бриллиантами). По заказам
        торговых организаций, мы производим изделия из 375 пробы.
      </p>
      <p>
        Мы доставляем товар через спецсвязь в Минск, Брест, Гомель, Витебск,
        Могилев, Гродно и другие города Беларуси за свой счет.
      </p>
      <p>
        Для юридических лиц и индивидуальных предпринимателей, осуществляющих
        торговлю ювелирными изделиями, наше предприятие также производит
        <strong>переработку неликвидного товара на более ходовые виды изделий
        на давальческой основе</strong>. В последнее время такой вид
        деятельности приобретает все большую популярность.
      </p>
      <p>
        Наша организация также принимает заявки от торговых организаций на
        изготовление ювелирных изделий по их собственному дизайну. При этом
        уровень цен на такие изделия не превышает уровень при массовом
        производстве.
      <p>
        Приглашаем к сотрудничеству партнеров занимающихся оптовой и
        розничной торговлей ювелирными изделиями. Будем рады взаимовыгодному
        сотрудничеству с теми, кто еще не стал нашим деловым партнером,
        и надеемся увидеть Вас в их числе!
      </p>
    </section>
  </div>
</template>

<script>
import ImageOverlay from '../components/the-content/utils/ImageOverlay'
import utils from './utils'

export default {
  name: 'AboutPage',
  components: { ImageOverlay },
  data () {
    return {
      section: {},
      categoriesLinksImages: [],
      categoriesLinks: [
        {
          route: '/about/manufacturing',
          tag: 'manufacturing-process',
          image: {},
          text: 'Узнайте, как создаются украшения!'
        },
        {
          route: '/about/team',
          tag: 'about-team',
          image: {},
          text: 'Узнайте больше о наc!'
        }
      ],
      title: 'О компании'
    }
  },
  metaInfo () {
    return {
      title: this.title,
      meta: utils.getDefaultMetaTags({
        description: this.section.meta_description,
        path: this.$router.resolve(this.$route).href,
        title: this.title,
        imageUrl: this.imageForMeta.image,
        imageWidth: this.imageForMeta.width,
        imageHeight: this.imageForMeta.height
      })
    }
  },
  mounted () {
    this.getSection()
    this.getCategoriesLinksImages()
  },
  updated () {
    if (Object.keys(this.section).length > 0 &&
        this.categoriesLinksImages.length > 0 &&
        window['__PRERENDER_INJECTED']) {
      document.dispatchEvent(new Event('render-event'))
    }
  },
  computed: {
    imageForMeta: function () {
      return (this.categoriesLinksImages.length > 0)
        ? this.categoriesLinksImages[0] : {}
    }
  },
  methods: {
    getSection: function () {
      const apiHost = process.env.API_HOST
      this.$http
        .get(`${apiHost}/api/v1/site-structure/get-section-with-categories/about`)
        .then(response => { this.section = response.body })
    },
    getCategoriesLinksImages: function () {
      const uri = `${process.env.API_HOST}/api/v1/images/get-images-by-tags`
      const repairTags = ['about-page', 'category-link']
      let uriParams = {include_tags: repairTags.join(',')}

      this.$http
        .get(uri, {params: uriParams})
        .then(response => {
          this.categoriesLinksImages = response.body
          this.updateCategoriesLinksWithImages()
        })
    },
    updateCategoriesLinksWithImages: function () {
      this.categoriesLinks = this.categoriesLinks.map(function (item) {
        let imageProps = this.getImageByTag(item.tag)
        item.image = imageProps
        return item
      }, this)
    },
    getImageByTag: function (tag) {
      return this.categoriesLinksImages.find(function (image) {
        return image.tags.includes(tag)
      })
    }
  }
}
</script>

<style scoped lang="scss">
  .about {
    @include page-block-vertical-padding();
    & > * {
      margin-bottom: 2em !important;
      &:last-child { margin-bottom: 0 !important; }
    }
    & > .about-links {
      display: flex;
      flex-wrap: wrap;
      @include centered-block-width(
        $desktop: 80%, $big-tablet: 90%, $small-tablet: 100%, $mobile: 100%);

      @media only print {
        display: block;
      }

      & > .about-link-wrapper {
        margin: 0;
        @include media(">tablet") { flex-basis: 50%; };
        @include media("<=tablet") { flex-basis: 100%; };
        @media only print {
          display: block;
          page-break-inside: avoid;
          margin-bottom: 1cm;
          &:last-child { margin-bottom: 0; }
        }
        & > a {
          display: block;
          text-decoration: none;
          font-family: "Cormorant Light", $font-stack;
          font-size: 1.5em;
          letter-spacing: 0.2em;
          text-transform: uppercase;
          & >>> h2 {
            font-size: 1em;
            font-weight: normal;
            margin-bottom: 0;
            color: inherit;
          }
        }
      }
    }
    & > .text-block {
      @include text-block();
    }
    & > .to-jewelry-stores-owners {
      a {
        color: $default-text-color;
        &:hover { color: $default-link-color; }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/AboutPage.vue